/**
 * Standout Review share/edit paths reset or cancel one delivery clock.
 * A missing provider makes those calls no-ops so a card can render alone.
 */
import { createContext, type ReactNode, useContext, useMemo } from "react"

import { type SessionShareTarget } from "./standoutSessionGroups"

export type FamilyDeliveryApi = {
  reset: (studentId: string, classSessionId: string | null | undefined) => void
  unshared: (
    studentId: string,
    classSessionId: string | null | undefined,
    excluding: SessionShareTarget
  ) => void
  notifyAt: (
    studentId: string,
    classSessionId: string | null | undefined
  ) => string | null
}

const noopApi: FamilyDeliveryApi = {
  reset: () => undefined,
  unshared: () => undefined,
  notifyAt: () => null,
}

const FamilyDeliveryContext = createContext<FamilyDeliveryApi>(noopApi)

export const FamilyDeliveryProvider = ({
  value,
  children,
}: {
  value: FamilyDeliveryApi
  children: ReactNode
}) => {
  const stable = useMemo(() => value, [value])
  return (
    <FamilyDeliveryContext.Provider value={stable}>
      {children}
    </FamilyDeliveryContext.Provider>
  )
}

export const useFamilyDelivery = (): FamilyDeliveryApi =>
  useContext(FamilyDeliveryContext)
